'use strict';

module.exports = require('./Trigger');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-trigger/lib/index.js
 ** module id = 27
 ** module chunks = 0
 **/